export const REPO_HIT_LIST_LOADING = 'REPO_HIT_LIST/LOADING';
export const REPO_HIT_VEHICLE_MODAL_TYPE = 'REPO_HIT_LIST/VEHICLE_MODAL';
export const REPO_HIT_RESET_STATE_TYPE = 'REPO_HIT_LIST/RESET_STATE';
export const REPO_HIT_ON_SEARCH_TYPE = 'REPO_HIT_LIST/ON_SEARCH';
export const REPO_HIT_TOGGLE_SHOULD_SEARCH_TYPE = 'REPO_HIT_LIST/TOGGLE_SHOULD_SEARCH';
export const REPO_HIT_ON_BRANCH_CHANGE_TYPE = 'REPO_HIT_LIST/ON_BRANCH_CHANGE';

export const SEARCH_REPO_HIT_LIST_THUNK_TYPE = 'REPO_HIT_LIST/SEARCH_LIST';
export const SEARCH_REPO_HIT_LIST_ERROR_MSG = 'Error searching the repossession hit list.';

export const CREATE_SPOTTED_NOTE_THUNK_TYPE = 'REPO_HIT_LIST/CREATE_SPOTTED_NOTE';
export const CREATE_SPOTTED_NOTE_ERROR_MSG = 'Error creating the spotted note.';

export const FETCH_SPOTTED_NOTES_THUNK_TYPE = 'REPO_HIT_LIST/FETCH_SPOTTED_NOTES';
export const FETCH_SPOTTED_NOTE_ERROR_MSG = 'Error fetching the spotted note.';

export const EDIT_SPOTTED_NOTE_THUNK_TYPE = 'REPO_HIT_LIST/EDIT_SPOTTED_NOTE';
export const EDIT_SPOTTED_NOTE_ERROR_MSG = 'Error editing the spotted note.';

export const COUNT_ORDER_TYPE_THUNK_TYPE = 'REPO_HIT_LIST/COUNT_ORDER_TYPE_THUNK_TYPE';
export const COUNT_ORDER_TYPE_ERROR_MSG = 'Error counting order types.';

export const COUNT_REACH_STATUS_THUNK_TYPE = 'REPO_HIT_LIST/COUNT_REACH_STATUS_THUNK_TYPE';
export const COUNT_REACH_STATUS_ERROR_MSG = 'Error counting reach status.';

export const COUNT_RHL_THUNK_TYPE = 'REPO_HIT_LIST/COUNT_RHL_THUNK_TYPE';
export const COUNT_RHL_ERROR_MSG = 'Error counting the RHL records.';

export const ASSIGN_ON_CASE_TYPE = 'REPO_HIT_LIST/ASSIGN_ON_CASE';
export const ASSIGN_ON_CASE_ERROR_MSG = 'Error assigning users to the case.';

export const CHANGE_COLLATERAL_COLOR_TYPE = 'REPO_HIT_LIST/CHANGE_COLLATERAL_COLOR';

export const REPO_HIT_LIST_INITIAL_STATE = {
  searchQuery: null,
  repoHitList: [],
  vehicleModalData: null,
  mapData: null,
  vehicleModalSpottedNotesData: null,
  repoHitListLoading: false,
  fetchSpottedNotesLoading: true,
  createSpottedNoteLoading: false,
  repoHitListCount: 0,
  accessibleCount: 0,
  obstructedCount: 0,
  allOrderTypeCount: 0,
  voluntaryCount: 0,
  involuntaryCount: 0,
  impoundCount: 0,
  totalCount: 0,
  skipAmount: 0,
  loading: false,
  loadingOrderTypeCounter: true,
};
